module.exports = __webpack_public_path__ + "static/media/hand3.bd65fad7.png";